/**
 * Company Values Data
 * 
 * Centralized data for company values and principles.
 * 
 * @module data/values
 */

import { Value } from "@/types/common";
import trustPartnershipImage from "@/assets/trust-partnership-optimized.jpg";
import safetyQualityImage from "@/assets/terminal-port-development-1.jpg";
import innovationDisciplineImage from "@/assets/innovation-discipline.jpg";
import peopleLeadershipImage from "@/assets/people-leadership.jpg";
import globalMindsetImage from "@/assets/global-mindset.jpg";
import sustainableExcellenceImage from "@/assets/sustainable-excellence.jpg";

/**
 * Core company values with associated imagery
 */
export const companyValues: Value[] = [
  {
    image: trustPartnershipImage,
    title: "Trust & Partnership",
    description: "Building lasting relationships through transparency, clear communication, and mutual respect with clients, teams, and stakeholders.",
    alt: "Trust and Partnership in logistics operations",
  },
  {
    image: safetyQualityImage,
    title: "Safety & Quality",
    description: "Zero-compromise approach to cargo safety, regulatory compliance, and operational excellence in every project.",
    alt: "Safety and Quality in port operations",
  },
  {
    image: innovationDisciplineImage,
    title: "Innovation with Discipline",
    description: "Embracing digitalization and modern solutions while maintaining financial discipline and measurable results.",
    alt: "Innovation with Discipline in maritime logistics",
  },
  {
    image: peopleLeadershipImage,
    title: "People-Centered Leadership",
    description: "Empowering teams through delegation, accountability, and continuous development in a culture of shared responsibility.",
    alt: "People-Centered Leadership in logistics teams",
  },
  {
    image: globalMindsetImage,
    title: "Global Mindset",
    description: "Operating across borders with cultural awareness, strategic partnerships, and commitment to sustainable growth.",
    alt: "Global Mindset connecting international logistics networks",
  },
  {
    image: sustainableExcellenceImage,
    title: "Sustainable Excellence",
    description: "Integrating environmental, social, and governance standards into every aspect of our operations.",
    alt: "Sustainable Excellence in modern logistics",
  },
];
